(function ($) {
	$(() => {

		if ($('.youtube-player-wrapper').length) {

			if (typeof (onYouTubeIframeAPIReady) === 'undefined') {
				const tag = document.createElement('script');
				tag.src = "https://www.youtube.com/iframe_api";
				const firstScriptTag = document.getElementsByTagName('script')[0];
				firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
			}

			$('.youtube-player').on('click', function () {
				const $that = $(this);


				if (!$(this).hasClass('wasPaused')) {
					$that.parent().addClass('paused');
					$that.addClass('wasPaused');
					$(this).append(`<iframe src="https://www.youtube.com/embed/${$(this).data('id')}?autoplay=1&rel=0&enablejsapi=1&modestbranding=1&disablekb=1&origin=${document.location.origin}" frameborder="0" allow="autoplay" allowfullscreen="1"></iframe>`);

					const player = new YT.Player($that.find('iframe')[0], {
						events: {
							'onStateChange': function (event) {
								if (event.target.getPlayerState() === 0) {
									player.stopVideo();
									$that.addClass('wasPaused');
									$that.parent().addClass('paused');

								}

								if (event.target.getPlayerState() === 1) {
									$that.removeClass('wasPaused');
									$that.parent().removeClass('paused');
									$that.removeClass('wasStoped');
									$that.parent().removeClass('stopped');
								}


								if (event.target.getPlayerState() === 2) {
									$that.addClass('wasPaused');
									$that.parent().addClass('paused');
								}
							}
						}
					});

				} else {
					$(this).find('iframe')[0].contentWindow.postMessage('{"event":"command","func":"' + 'playVideo' + '","args":""}', '*');
				}
			});

			const yplayers = document.querySelectorAll('.youtube-player-wrapper');

			const videoObserver = new IntersectionObserver(entries => {
				$.each(entries, (i, entry) => {

					if (entry.intersectionRatio > 0) {
						$(entry.target).find('.youtube-player').each(function () {
							if (!$(this).hasClass('wasPlayed')) {
								/*       $(this).html(`<iframe src="https://www.youtube.com/embed/${$(this).data('id')}?autoplay=1&amp;rel=0&amp;enablejsapi=1" frameborder="0" allow="autoplay" allowfullscreen="1"></iframe>`); */
								$(this).trigger('click');
								$(this).addClass('wasPlayed');
							} else {
								$(this).find('iframe')[0].contentWindow.postMessage('{"event":"command","func":"' + 'playVideo' + '","args":""}', '*');
							}

						});
					} else {
						$(entry.target).find('.youtube-player').each(function () {

							if ($(this).find('iframe').length === 1) {
								$(this).find('iframe')[0].contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
							}
						});
					}
				});
			});

			window.onYouTubeIframeAPIReady = function () {
				$.each(yplayers, (i, yplayer) => {
					if (!$(yplayer).hasClass('manualstart')) {
						videoObserver.observe(yplayer);
					}

				});
			}
		}
	});
})(jQuery);